module.exports = __webpack_public_path__ + "img/resized-APP-0024-2.148ae888.png";